




































const url = '/Tenant';

import Vue from 'vue';
import Login from './components/Login.vue';

interface Item {
  id: string | null;
  tenantId: string;
  name: string;
  subscriptionKey: string;
  isEnabled: boolean;
  endDate: string | null;
  licensedUserCount: number;
  hasDesignerLicence: boolean;
}

export default Vue.extend({
  name: 'app',
  data: () => ({
    login: {
      usr: '',
      pwd: '',
      done: false
    },
    items: [] as Item[]
  }),
  methods: {
    async onLogin(usr: string, pwd: string) {
      this.login.usr = usr;
      this.login.pwd = pwd;
      await this.load();
    },
    async load(): Promise<void> {
      this.items = [];
      let req = new Request(url, { method: 'GET', headers: new Headers({ 'Authorization': this.authHeaderValue }) });
      const resp = await fetch(req);
      if (resp.status != 200) {
        alert(`HTTP ${resp.status}`);
        const txt = await resp.text();
        if (txt != '') {
          alert(txt);
        }
      } else {
        const got = await resp.json() as any[];
        this.items = got.map(i => {
          i.endDate = i.endDate == null ? null : new Date(Date.parse(i.endDate)).toISOString();
          return i;
        });
        this.login.done = true;
      }
    },
    addNew() {
      const nw = {
        id: null,
        isEnabled: true,
      } as Item;
      this.items.push(nw);
    },
    async save(item: Item): Promise<void> {
      const isNew = item.id == null;

      if(item.endDate != null) {
        item.endDate = new Date(item.endDate).toISOString();
      }
      if (item.subscriptionKey != null) {
        item.subscriptionKey = item.subscriptionKey.trim();
      }
      const body = JSON.stringify(item);

      let req = isNew ?
        new Request(url, { method: 'POST', body: body }) :
        new Request(`${url}/${item.id}`, { method: 'PATCH', body: body });
      req.headers.set('Authorization', this.authHeaderValue);
      req.headers.set('Content-Type', 'application/json');
      const resp = await fetch(req);
      if (resp.status != 200) {
        alert(`ERROR: HTTP ${resp.status}`);
        const err = await resp.json();
        if (err && err.errors) {
          console.log('error', err);
          Object.entries(err.errors).forEach(([k, v]) => alert(`ERROR; ${k}: ${(<string[]>v)[0]}`));
        }
      } else {
        await this.load();
      }
    }
  },
  computed: {
    authHeaderValue() : string {
      let v = `${this.login.usr}:${this.login.pwd}`;
      v = btoa(v);
      return `Basic ${v}`;
    }
  },
  components: {
    Login
  }
});
